export const FETCH_FAQ_START = 'FETCH_FAQ_START';
export const FETCH_FAQ_SUCCESS = 'FETCH_FAQ_SUCCESS';
export const FETCH_FAQ_FAILED = 'FETCH_FAQ_FAILED';
